<template>
  <section class="app-main">
    <transition name="fade-transform" mode="out-in">
      <router-view :key="key" />
    </transition>
  </section>
</template>

<script>
export default {
  name: 'AppMain',
  computed: {
    key() {
      return this.$route.path + new Date()
    }
  }
}
</script>

<style scoped>
.app-main {
  min-height: calc(100vh - 105px);
  width: 100%;
  position: relative;
  overflow: hidden;
  background: #F2F2F2;
  padding: 10px;
}
</style>

<style lang="scss">
// fix css style bug in open el-dialog
// .el-popup-parent--hidden {
//   .fixed-header {
//     padding-right: 15px;
//   }
// }
</style>
